// Dynamic tracking script loader — fetches config from backend then injects
// GA4, Meta Pixel, and Microsoft Clarity. Idempotent — safe to call multiple times.

let _initialized = false;

export async function initTracking(backendUrl) {
  if (_initialized) return;
  _initialized = true; // Guard against double-init even on failure.

  try {
    if (!backendUrl) return;
    const res = await fetch(`${backendUrl}/api/settings/analytics/public`);
    if (!res.ok) return;
    const config = await res.json();
    if (!config || !config.tracking_enabled) return;

    // ── GA4 ──
    if (config.ga4_measurement_id) {
      const script = document.createElement('script');
      script.async = true;
      script.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(config.ga4_measurement_id)}`;
      document.head.appendChild(script);
      window.dataLayer = window.dataLayer || [];
      window.gtag = function () {
        window.dataLayer.push(arguments);
      };
      window.gtag('js', new Date());
      window.gtag('config', config.ga4_measurement_id, { send_page_view: false });
    }

    // ── Meta Pixel ──
    if (config.meta_pixel_id) {
      !(function (f, b, e, v, n, t, s) {
        if (f.fbq) return;
        n = f.fbq = function () {
          n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
        };
        if (!f._fbq) f._fbq = n;
        n.push = n;
        n.loaded = !0;
        n.version = '2.0';
        n.queue = [];
        t = b.createElement(e);
        t.async = !0;
        t.src = v;
        s = b.getElementsByTagName(e)[0];
        s.parentNode.insertBefore(t, s);
      })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
      window.fbq('init', config.meta_pixel_id);
      window.fbq('track', 'PageView');
    }

    // ── Microsoft Clarity ──
    // Loaded separately via `src/utils/clarity.js` in the deferred boot chain
    // (index.js -> _scheduleDeferred). No inline injection here so this
    // module stays focused on GA4 + Meta Pixel only.
  } catch (e) {
    // eslint-disable-next-line no-console
    console.warn('[Tracking] init failed silently:', e);
  }
}

export function clarityIdentify(userId, email) {
  try {
    // Backwards-compat shim: delegate to the queue-shim-backed util.
    // eslint-disable-next-line global-require
    const { clarityIdentify: _identify } = require('./clarity');
    _identify(userId, email);
  } catch {
    // ignore
  }
}

export function clarityTag(key, value) {
  try {
    // eslint-disable-next-line global-require
    const { clarityTag: _tag } = require('./clarity');
    _tag(key, value);
  } catch {
    // ignore
  }
}
